import { Segmented } from 'antd'

interface SegmentedProps {
  options: string[]
}

export { Segmented }
export type { SegmentedProps }
